<template>
    <el-dialog class="common-dialog"
               :class="[reportPDFUrl ? 'freedom pdf-dialog' : 'hintHandle']"
               :title="title"
               :visible="showReport"
               :center="true"
               :before-close="closeDialog">
        <div class="report-fail" v-if="title">
            <el-button type="primary" @click="perfectInfo">去完善信息</el-button>
        </div>
        <div class="report-main" v-if="reportPDFUrl">
            <div class="report-iframebg">
                <i class="el-icon-loading"></i>
                <p>加载中</p>
            </div>
            <iframe class="lineBlock report-iframe" :src="reportPDFUrl" frameborder="0"></iframe>
            <div class="report-mark"></div>
            <div class="lineBlock report-right">
                <div class="report-r-float">
                    <div class="report-right-1">
                        <img class="logo" src="../../content/images/logo-2.png" alt="旋涡营销">
                        <p class="hint">让网络营销 变简单</p>
                    </div>
                    <div class="report-right-2">
                        <img class="qrcode" src="../../content/images/qrcode-mobile.jpg" alt="旋涡营销手机版">
                        <p class="hint">手机版本 更便捷</p>
                    </div>
                    <div class="report-right-3">
                        <el-button class="save-btn" type="primary" :disabled="saveBtnDisabled" @click="downloadPDF" v-bd-track-event="['营销力诊断', '点击保存到电脑']">保存到电脑</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    export default {
        data() {
            return {
                title: '',
                reportPDFUrl: '',
                saveBtnDisabled: false
            }
        },
        created() {
            this.hasCreateReport().then(() => {
                this.reportPDFUrl = this.getReportPDFUrl;
                setTimeout(() => { this.computePosition() }, 50);
            }, err => {
                this.title = err;
            })
        },
        mounted() {
            if (this.$el) {
                this.$el.addEventListener('scroll', () => {
                    this.computePosition();
                });
                window.addEventListener('resize', () => {
                    this.computePosition();
                })
            }
        },
        computed: {
            ...mapState('check', ['showReport']),
            ...mapGetters('check', ['getReportPDFUrl', 'downloadPDFUrl'])
        },
        methods: {
            ...mapMutations('check', ['setReportVisible']),
            ...mapActions('check', ['hasCreateReport']),
            //关闭窗口
            closeDialog () {
                this.setReportVisible(false);
            },
            //完善信息
            perfectInfo () {
                this.closeDialog();
                this.$router.push({name: 'user-basic'});
            },
            //计算右侧位置
            computePosition() {
                let $el = this.$el,
                    $rf_el = $el.getElementsByClassName('report-r-float')[0],
                    $dialog_el = $el.getElementsByClassName('el-dialog')[0],
                    $r_el = $el.getElementsByClassName('report-right')[0],
                    $btn_el = $el.getElementsByClassName('el-dialog__headerbtn')[0];
                if ($rf_el && $r_el) {
                    $rf_el.style.height = $el.clientHeight + 'px';
                    let scrollTop = $el.scrollTop > $dialog_el.offsetTop ? $el.scrollTop - $dialog_el.offsetTop : $el.scrollTop;
                    $r_el.style.paddingTop = scrollTop + 'px';
                    $btn_el.style.top = 20 + scrollTop + 'px';
                }
            },
            //下载pdf文件
            downloadPDF () {
                window.open(this.downloadPDFUrl);
                //保存完5秒后才能再次保存
                this.saveBtnDisabled = true;
                setTimeout(() => {
                    this.saveBtnDisabled = false;
                }, 5000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .report-fail {
        text-align: center;
        .el-button {
            width: 220px;
            height: 60px;
            font-size: 21px;
            color: #fff;
            margin-top: 36px;
        }
    }
    .report-main {
        font-size: 0;
        white-space: nowrap;
        padding-right: 200px;
        > div {
            vertical-align: top;
        }
    }
    .report-iframebg {
        position: absolute;
        top: 0;
        left: 0;
        width: 92%;
        height: 841.89px;
        font-size: 18px;
        text-align: center;
        padding-top: 200px;
        background-color: #fff;
    }
    $reportHeight: 841.89px * 3 + 60px + 800px;
    .report-iframe {
        position: relative;
        width: 100%;
        height: $reportHeight;
    }
    .report-mark {
        position: absolute;
        top: 50px;
        left: 0;
        width: 100%;
        height: 100%;
    }
    @mixin report-r-flex() {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
    }
    .report-right {
        $color: #d0d0d0;
        position: relative;
        top: 0;
        right: 20px;
        width: 200px;
        height: $reportHeight;
        text-align: center;
        background-color: #fff;
        overflow: hidden;
        .report-r-float {
            height: 776px;
            min-height: 450px;
        }
        .report-right-1 {
            @include report-r-flex;
            height: 32%;
            border-bottom: 1px solid $color;
        }
        .report-right-2 {
            @include report-r-flex;
            height: 28%;
            border-bottom: 1px solid $color;
        }
        .report-right-3 {
            height: 40%;
        }
        .logo {
            height: 50%;
        }
        .hint {
            font-size: 0.9rem;
            color: $color;
            margin-bottom: 0;
        }
        .qrcode {
            height: 57.5%;
        }
        .save-btn {
            width: 65%;
            height: 15%;
            line-height: 15%;
            font-size: .9rem;
            color: #fff;
            padding: 0;
            margin-top: 15%;
        }
    }
</style>
<style lang="scss">
    .common-dialog.hintHandle {
        .el-dialog {
            margin-top: -125px;
        }
    }
    .common-dialog.pdf-dialog {
        .el-dialog {
            width: 90%;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/ReportPDF.vue